import { AdminInvoiceProfile } from '../model/adminInvoiceProfile';
export class AdminInvoiceProfileBuilder {
    static buildAdminInvoiceProfile(data) {
        const adminInvoiceProfile = new AdminInvoiceProfile();
        adminInvoiceProfile.id = data.id;
        adminInvoiceProfile.id_client = data.id_client;
        adminInvoiceProfile.client_active = data.client_active;
        adminInvoiceProfile.client_email = data.client_email;
        adminInvoiceProfile.client_last_name = data.client_last_name;
        adminInvoiceProfile.client_name = data.client_name;
        adminInvoiceProfile.type = data.type;
        adminInvoiceProfile.monthly_invoice = data.monthly_invoice;
        adminInvoiceProfile.invoice_name = data.invoice_name;
        adminInvoiceProfile.invoice_nif = data.invoice_nif;
        adminInvoiceProfile.invoice_email = data.invoice_email;
        adminInvoiceProfile.invoice_address = data.invoice_address;
        adminInvoiceProfile.invoice_city = data.invoice_city;
        adminInvoiceProfile.invoice_state = data.invoice_state;
        adminInvoiceProfile.invoice_zip = data.invoice_zip;
        adminInvoiceProfile.invoice_country = data.invoice_country;
        adminInvoiceProfile.send_invoice_copy = data.send_invoice_copy;
        adminInvoiceProfile.send_reservation_copy = data.send_reservation_copy;
        adminInvoiceProfile.id_company = data.id_company;
        adminInvoiceProfile.id_costcenter = data.id_costcenter;
        adminInvoiceProfile.level = data.level;
        return adminInvoiceProfile;
    }
}
//# sourceMappingURL=adminInvoiceProfile-builder.js.map